"use client";

import React from "react";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const products = [{
  id: 1,
  name: "CEMENT & CONCRETE",
  price: "AUD 100 - 2,000",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/cement_concrete.png"
}, {
  id: 2,
  name: "STEEL & METAL",
  price: "AUD 150 - 1,800",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/steel_metal.png"
}, {
  id: 3,
  name: "PLUMBING & PIPING",
  price: "AUD 100 - 1,500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/plumbing_piping.png"
}, {
  id: 4,
  name: "ELECTRICAL HARDWARE",
  price: "AUD 120 - 2,000",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/electrical_hardware.png"
}, {
  id: 5,
  name: "TOOLS & EQUIPMENT",
  price: "AUD 200 - 2,000",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/tools_equipment.png"
}, {
  id: 6,
  name: "BUILDING SUPPLIES",
  price: "AUD 100 - 1,200",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/building_supplies.png"
}, {
  id: 7,
  name: "STRUCTURAL TIMBER",
  price: "AUD 300 - 2,000",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/structural_timber.png"
}, {
  id: 8,
  name: "ROOFING MATERIALS",
  price: "AUD 250 - 1,900",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/roofing_materials.png"
}, {
  id: 9,
  name: "INSULATION PRODUCTS",
  price: "AUD 100 - 800",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/insulation_products.png"
}, {
  id: 10,
  name: "FIXINGS & FASTENERS",
  price: "AUD 100 - 500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/fasteners_fixings.png"
}];
export default function ProfessionalGearHighlights() {
  return <section data-section-id="102944" id="wholesale-core-categories" className="bg-background text-foreground py-10 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-serif tracking-tight uppercase">
            Wholesale Core Categories
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6">
          {products.map((product, i) => <Card key={product.id} data-index={i} className="border border-border rounded-sm overflow-hidden transition-all duration-300 hover:border-ring hover:shadow-lg flex flex-col gap-0 p-0 shadow-sm bg-card">
              <div className="bg-muted/30 p-4 flex justify-center items-center aspect-square border-b border-border/40">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300" loading="lazy" />
              </div>
              <CardContent className="p-3 flex-grow flex flex-col justify-start gap-1">
                <h3 className="text-[12px] text-muted-foreground font-sans font-bold leading-tight line-clamp-2 uppercase tracking-wider">
                  {product.name}
                </h3>
                <p className="font-mono font-bold text-foreground text-[14px] mt-1">
                  {product.price}
                </p>
              </CardContent>
              <CardFooter className="p-3 pt-0 mt-auto">
                <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm text-[12px] font-bold h-auto py-2 px-4 font-sans shadow-none transition-colors duration-200">
                  View Specs
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}